<template>
  <div class="avisos">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-4"></div>
      </div>
      <DialogBox ref="resultDialog"></DialogBox>
      <DialogBox ref="confirmationDialog"></DialogBox>
      <v-data-table
              :headers="headers"
              :items="avisos"
              sort-by="date"
              sort-desc
              class="elevation-1"
              locale='es'
              :footer-props="{
                'items-per-page-text': 'Filas por página',
                'sort-by-text' : 'Ordenar por'
              }"
              :loading="loading"
              loading-text="Cargando avisos..."
      >
        <template v-slot:top>
          <v-toolbar class="toolbars" flat>
            <v-toolbar-title>Avisos</v-toolbar-title>
            <v-divider
                    class="mx-4"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn dark class="mb-2 toolbar-button" v-on="on">Crear nuevo aviso</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-menu
                        v-model="datepicker1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.date"
                            label="Fecha del aviso"
                            prepend-icon="fa fa-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="es" color="var(--color-calendar)" first-day-of-week=1 v-model="editedItem.date" @input="datepicker1 = false"></v-date-picker>
                      </v-menu>
                    </v-row>
                    <v-row justify="center">
                      <v-menu
                        v-model="datepicker2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.endDate"
                            label="Fecha fin de validez"
                            prepend-icon="fa fa-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker locale="es" color="var(--color-calendar)" first-day-of-week=1 v-model="editedItem.endDate" @input="datepicker2 = false"></v-date-picker>
                      </v-menu>
                    </v-row>
                    <ul em>
                      <li>
                        <v-text-field v-model="editedItem.asunto" label="Asunto"></v-text-field>
                      </li>
                      <li>
                        <v-textarea
                                v-model="editedItem.cuerpo"
                                color="teal"
                                label="Cuerpo"
                        >
                        </v-textarea>
                      </li>
                    </ul>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="saveConfirmation">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
                  large
                  class=" mr-2 fa fa-edit " aria-hidden="true"
                  @click="editItem(item)"
          >
          </v-icon>
          <v-icon
                  large
                  @click="deleteConfirmation(item)"
                  class="fa fa-trash " aria-hidden="true"
          >
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>

    </div>

  </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import DialogBox from '../components/DialogBox';
import { DB } from '../firebase/db'
var moment = require('moment');

export default {
  name: 'avisos',
  created() {
    this.$emit('updateTitle', 'Avisos');
    this.initialize();
    window.bus.$emit('menu/activarMenu');
  },
  data: () => ({
      loading : true,
      dialog: false,
      datepicker1 : false,
      datepicker2 : false,
      headers: [
        { text: 'Asunto', value: 'asunto', sortable: false },
        {
          text: 'Fecha asunto',
          align: 'left',
          value: 'formattedDate',
          sortable: false,
        },
        { text: 'Fecha fin de validez', value: 'formattedEndDate', sortable: false},
        { text: 'Cuerpo', value: 'cuerpo', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],
      avisos: [],
      editedIndex: -1,
      editedItem: {
        date: moment().format("YYYY-MM-DD"),
        endDate: moment().add(7, 'days').format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
      deletedItem: {
        date: moment().format("YYYY-MM-DD"),
        endDate: moment().add(7, 'days').format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
      defaultItem: {
        date: moment().format("YYYY-MM-DD"),
        endDate: moment().add(7, 'days').format("YYYY-MM-DD"),
        asunto: '',
        cuerpo: ''
      },
    }),

    components: {
      DialogBox
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo aviso' : 'Editar aviso'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {

        DB.collection('avisos').onSnapshot( snapshot => {
          snapshot.docs.forEach( item => {
            let element = {
              date : item.data().date,
              endDate : item.data().endDate,
              formattedDate : moment(item.data().date).format("DD-MM-YYYY"),
              formattedEndDate : moment(item.data().endDate).format("DD-MM-YYYY"),
              asunto : item.data().asunto,
              cuerpo : item.data().cuerpo,
              id : item.id
            };

            let index = -1;
            for (let i = 0; i < this.avisos.length; i++) {
              if(this.avisos[i].id == item.id)
              {
                index = i;
                break;
              }
            }

            if(index == -1){
              this.avisos.push(element);
            }
            else {
              this.avisos[index].id = element.id;
              this.avisos[index].date = element.date;
              this.avisos[index].endDate = element.endDate;
              this.avisos[index].formattedDate = moment(element.date).format("DD-MM-YYYY");
              this.avisos[index].formattedEndDate = moment(element.endDate).format("DD-MM-YYYY");
              this.avisos[index].asunto = element.asunto;
              this.avisos[index].cuerpo = element.cuerpo;
            }

            this.loading = false;
          })
        })
      },

      editItem (element) {

        this.editedIndex = this.avisos.indexOf(element);
        this.editedItem = Object.assign({}, element);
        this.dialog = true;
        
      },

      deleteConfirmation(element) {
        this.deletedItem = element;
        this.$refs.confirmationDialog.show('warning', 
        `¿Está seguro que desea eliminar el aviso con asunto '${this.deletedItem.asunto}'?`,
        true,
        this.deleteItem)
      },

      deleteSuccess() {
        this.$refs.resultDialog.show('info', 'Aviso eliminado con éxito.', false);
      },

      deleteItem () {

        return new Promise((resolve, reject) => {
          const index = this.avisos.indexOf(this.deletedItem);
          DB.collection('avisos').doc(this.deletedItem.id).delete().then( () => {
            this.avisos.splice(index, 1);
            this.deleteSuccess();
            resolve();
          })
          .catch( error => {
            console.error(error);
            this.errorDialog("Se ha producido un error al eliminar un elemento en la base de datos.");
            reject(error)
          })
        })
      },

      close () {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300)
      },

      saveConfirmation() {
        this.$refs.confirmationDialog.show('question', 
        `¿Está seguro que desea guardar el aviso con asunto ${this.editedItem.asunto}?`,
        true,
        this.save)
      },

      saveSuccess() {
        this.$refs.resultDialog.show('info', 'Aviso guardado con éxito.', false);
      },
      
      errorDialog(error) {
        this.$refs.resultDialog.show('error', error + " Compruebe la conexión a Internet. Si el problema persiste contacte con el administrador.", false);
      },

      save () {

        let item = {
            date : this.editedItem.date,
            endDate: this.editedItem.endDate,
            asunto : this.editedItem.asunto,
            cuerpo : this.editedItem.cuerpo,
        };

        return new Promise((resolve, reject) => {
          if (this.editedIndex > -1) {
          
            DB.collection('avisos').doc(this.editedItem.id).set(item)
            .then(() => {
              this.saveSuccess();
              resolve();
            })
            .catch( error => {
              console.error(error);
              this.errorDialog("Se ha producido un error al guardar un elemento en la base de datos.");
              reject(error);
            })
          } else {
            DB.collection('avisos').doc().set(item)
            .then(() => {
              this.saveSuccess();
              resolve();
            })
            .catch( error => {
              console.error(error);
              this.errorDialog("Se ha producido un error al guardar un elemento en la base de datos.");
              reject(error);
            }) 
          }
          this.close()
        })
      },
    },
}
</script>
